// @flow
import React from "react";
import QuickLinks from "@fdr/quick-links";
import UpcomingRaces from "@fdr/upcoming-races";
import TopRaces from "@fdr/top-races";
import { TopTracks } from "@fdr/tracks-builder";
import TopPools from "@fdr/top-pools";
import TracksComponents from "@fdr/tracks-builder/src/TracksType/types";
import ComponentSection from "@fdr/atomic-ui/_organisms/ComponentSection";
import VideoPlaylist from "@fdr/video-builder";
import FeaturedSection from "../components/featuredSection";
import type { ComponentMap, Props } from "./types";
import { ComponentType } from "../constraints/types";

const componentMap: ComponentMap = {
  QUICK_LINKS: {
    type: "fixed",
    render: (props: Props) => (
      <QuickLinks
        key="QUICK_LINKS"
        useQuickLinksExpanded={props.quickLinksExpanded}
        device={props.device}
        shouldUpdate={props.shouldUpdate}
      />
    )
  },
  TOP_RACES: {
    type: "full",
    render: (props: Props, context) => (
      <TopRaces
        key="TOP_RACES"
        title={props.title}
        shouldUpdate={props.shouldUpdate}
        rdaClient={context.rdaClient}
      />
    )
  },
  UPCOMING_RACES: {
    type: "full",
    render: (props: Props, context) => (
      <UpcomingRaces
        key="UPCOMING_RACES"
        title={props.title}
        subtitle={props.subtitle}
        device={props.device}
        shouldUpdate={props.shouldUpdate}
        rdaClient={context.rdaClient}
      />
    )
  },
  TOP_TRACKS: {
    type: "large",
    render: (props: Props, context) => (
      <TopTracks
        key="TOP_TRACKS"
        trackType={TracksComponents.TOP_TRACKS}
        title={props.title}
        device={props.device}
        shouldUpdate={props.shouldUpdate}
        rdaClient={context.rdaClient}
      />
    )
  },
  PROMO_WIDGET: {
    type: "small",
    render: () => <div key="PROMO_WIDGET" />
  },
  TOP_POOLS: {
    type: "small",
    render: (props: Props) => (
      <TopPools
        key="TOP_POOLS"
        title={props.title}
        shouldUpdate={props.shouldUpdate}
      />
    )
  },
  TALENT_PICKS: {
    type: "large",
    render: () => <div key="TALENT_PICKS" />
  },
  SEO_FOOTER: {
    type: "large",
    render: () => <div key="SEO_FOOTER" />
  },
  PROMO_BANNER_TOP: {
    type: "top",
    render: () => <div key="PROMO_BANNER_TOP" id="homepagePromoBanner_top" />
  },
  PROMO_BANNER_BOTTOM: {
    type: "bottom",
    render: () => (
      <div key="PROMO_BANNER_BOTTOM" id="homepagePromoBanner_bottom" />
    )
  },
  HOME_PLAYLIST: {
    type: "large",
    render: (props: Props) => (
      <ComponentSection title={props.title}>
        <VideoPlaylist key="HOME_PLAYLIST" />
      </ComponentSection>
    )
  },
  HORSE_RACING_101: {
    type: ComponentType.FULL,
    render: (props: Props) => (
      <ComponentSection title={props.title}>
        <FeaturedSection key="HORSE_RACING_101" />
      </ComponentSection>
    )
  },
  DEFAULT: {
    type: "default",
    render: () => <div key="default" />
  }
};

export default componentMap;
